module.exports = __webpack_public_path__ + "assets/d23ef143cd005b92c322f64cf765d8e3.png";